<template>
    <div class="counter">
        <div class="counter__info">
            <div class="counter--icon">
                <common-icon name="bell" size="gigantic"></common-icon>
                <p class="counter__info--circle">
                    <span class="counter__info--circle--number">{{ totalNumber - currentIndex + 1 }}</span>
                </p>
            </div>

            <p class="counter__info--heading">{{ pageHeading }}</p>
        </div>
        <p class="counter__total">{{ currentIndex }} / {{ totalNumber }}</p>
    </div>
</template>

<script>
    export default {
        components: {},

        props: {
            totalNumber: { type: Number, required: true },
            currentIndex: { type: Number, required: true },
        },

        computed: {
            pageHeading() {
                return this.$t('pages.referrals.referrals_complete.need_your_attention')
            },
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .counter {
        @include breakpoint(laptop) {
            flex-wrap: wrap;
        }
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 30px;

        &--icon {
            @include breakpoint(laptop) {
                flex-wrap: wrap;
            }
            position: relative;
            margin-right: 50px;
        }

        &__info {
            @include breakpoint(laptop) {
                flex-wrap: wrap;
                justify-content: center;
            }
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 28px;
            color: $color--txt-header-1;

            &--heading {
                text-align: center;
            }

            &--circle {
                position: absolute;
                bottom: 0;
                left: 40px;
                border-radius: 50%;
                width: 26px;
                height: 26px;
                padding: 10px;
                background: #fff;
                background-color: $color--accent-4;
                color: #000;
                text-align: center;
                font-size: 32px;

                &--number {
                    font-size: 12px;
                    position: absolute;
                    color: $color-white;
                    left: 50%;
                    top: 50%;
                    transform: translate(-50%, -50%);
                }
            }
        }

        &__total {
            color: $color--accent-1;
            font-size: 20px;
            font-weight: bold;
        }
    }
</style>
